import * as actions from "../actions/session";
import update from "immutability-helper";
import { setSafe } from "../../../util/storeHelper";
/**
 * reducer for changes to ephemeral session state
 */
export const sessionReducer = {
    reducers: {
        [actions.setKnownGames]: (state, payload) => update(state, { known: { $set: payload } }),
        [actions.setGameDisabled]: (state, payload) => setSafe(state, ["disabled", payload.gameId], payload.disabledBy),
        [actions.clearGameDisabled]: (state, payload) => update(state, { disabled: { $set: {} } }),
    },
    defaults: {
        known: [],
        disabled: {},
    },
};
